import type { Suggestion } from '../../aiSuggestionsPluginType';

/**
 * Collects every localId targeted by a suggestion's tool calls and remix action,
 * de-duplicated in first-seen order. Card anchor localIds are intentionally excluded.
 */
export function collectTargetLocalIds(suggestion: Suggestion): string[] {
	const ids: string[] = [];
	const add = (id: string | undefined) => {
		if (id && !ids.includes(id)) {
			ids.push(id);
		}
	};

	for (const toolCall of suggestion.toolCalls ?? []) {
		if (toolCall.name === 'removeNodes') {
			toolCall.arguments.localIds.forEach(add);
		} else {
			add(toolCall.arguments.localId);
		}
	}
	suggestion.action?.localIds?.forEach(add);

	return ids;
}
